<script>
    import { onMount } from 'svelte';
    import { io } from './store.js';

    onMount(() => {
        io.activePage = 'Setup';
    });
</script>

<div class='con-page'>
    <div class='con-dash'>
        <div class='landing-header y'>
            Setup Guide
        </div>

        <div style='margin: 70px 0px;'>
            <div class='step'>
                <div class='step-header'>Step 1</div>
                <div class='image-container'>
					<img src='step1.png' />
                </div>
                <p class='description'>Click on "Add to your Discord" button on the homepage.  Select the server you want to add the bot to.</p>
            </div>

            <div class='step'>
                <div class='step-header'>Step 2</div>
                <div class='image-container'>
                    <img src='step2.png' />
                </div>
                <p class='description'>Create a new channel for the bot to post in.</p>
            </div>

            <div class='step'>
                <div class='step-header'>Step 3</div>
                <div class='image-container'>
                    <img src='step3.png' />
                </div>
                <p class='description'>Navigate to server settings.</p>
            </div>
            <div class='step'>
                <div class='step-header'>Step 4</div>
                <div class='image-container'>
                    <img src='step4.png' />
                </div>
                <p class='description'>Navigate to the "Integrations" tab.</p>
            </div>

            <div class='step'>
                <div class='step-header'>Step 5</div>
                <div class='image-container'>
                    <img src='step5.png' />
                </div>
                <p class='description'>Disable permissions for "All Channels"</p>
            </div>

            <div class='step'>
                <div class='step-header'>Step 6</div>
                <div class='image-container'>
                    <img src='step6.png' />
                </div>
                <p class='description'>Add your newly created channel to the approved list.</p>
            </div>

            <div class='step'>
                <div class='step-header'>Step 7</div>
                <div class='image-container'>
                    <img src='step7.png' />
                </div>
                <p class='description'>Use the /bdropchannel command to set the channel where the bot will drop cards.</p>
            </div>
        </div>

        <hr />
    </div>
</div>

<style type="text/less">
    .con-page {
        display: grid;
    }

    .con-dash {
        display: grid;
        justify-self: center;
        width: 100%;
        max-width: var(--mwidth);
        margin-top: 10px;
        padding: 30px;
    }

    .landing-header {
        text-align: center;
        font-weight: bold;
        font-size: 3em;
    }

    .step {
        margin-bottom: 40px;
        background: rgba(255, 255, 255, 0.1);
        padding: 2rem;
        border-radius: 10px;
        text-align: center;
    }

    .step-header {
        text-align: center;
        font-weight: bold;
        font-size: 1.5em;
    }

    .image-container {
        width: 100%;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 8px;
        margin: 1rem 0;
        display: flex;
        align-items: center;
        justify-content: center;

		img{
			height:100%;
		}
    }

    .description {
        margin-top: 1rem;
        line-height: 1.5em;
        font-family: Open Sans, sans-serif;
        font-weight: 600;
    }
</style> 